import { nameof } from "ts-simple-nameof";
import { IBlockedTimeWizardFormModel } from "../models/blockedTimeWizardFormModel";
import { HiddenField } from "../../../../../common/components/forms/inputs/hiddenField/HiddenField";
import { DefaultFormSelectField } from "../../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { IEmployeeWithAvailabilityModel } from "../../../../../common/components/forms/inputs/instructorCalendar/models/employeeCalendarModels";
import { IBreakTypeSelectModel } from "../models/breakTypeSelectModel";
import { EmployeeCalendar } from "../../../../../common/components/forms/inputs/instructorCalendar/EmployeeCalendar";
import { TimeDurationField } from "../../../../../common/components/forms/inputs/timeDurationField/TimeDurationField";
import { RangeCalendar } from "../../../../../common/components/forms/inputs/RangeCalendar/RangeCalendar";
import { DefaultDateField } from "../../../../../common/components/forms/inputs/dateField/DefaultDateField";
import { PageMode } from "../../../../../common/types";

interface IBlockedTimeWizardMainInputsProps {
  studioEmployees?: IEmployeeWithAvailabilityModel[];
  breakTypes?: IBreakTypeSelectModel[];
  isLoading: boolean;
  isFullDay: boolean;
  pageMode: PageMode;
}

export const BlockedTimeWizardMainInputs = ({
  studioEmployees,
  breakTypes,
  isLoading,
  isFullDay,
  pageMode,
}: IBlockedTimeWizardMainInputsProps) => {
  return (
    <>
      <HiddenField
        name={nameof<IBlockedTimeWizardFormModel>((x) => x.studioId)}
      />
      <HiddenField name={nameof<IBlockedTimeWizardFormModel>((x) => x.type)} />

      <DefaultFormSelectField
        name={nameof<IBlockedTimeWizardFormModel>((x) => x.breakTypeId)}
        label="Тип блокирано време"
        options={breakTypes}
        required
        tooltip="Изберете типа на блокираното време от наличните варианти."
        disabled={isLoading}
      />

      {isFullDay ? (
        <>
          <DefaultFormSelectField
            name={nameof<IBlockedTimeWizardFormModel>((x) => x.employeeId)}
            label="Служител"
            options={studioEmployees}
            required
            disabled={isLoading}
          />

          {pageMode === "edit" ? (
            <DefaultDateField
              name={nameof<IBlockedTimeWizardFormModel>((x) => x.date)}
              label="Ден"
              required
            />
          ) : (
            <RangeCalendar
              dateFromName={nameof<IBlockedTimeWizardFormModel>((x) => x.date)}
              dateToName={nameof<IBlockedTimeWizardFormModel>((x) => x.endDate)}
              label="От дата до дата (включително)"
              required
            />
          )}
        </>
      ) : (
        <>
          <TimeDurationField
            name={nameof<IBlockedTimeWizardFormModel>(
              (x) => x.durationInMinutes,
            )}
            label="Продължителност"
            required
            tooltip="Продължителността се попълва автоматично според избрания тип блокирано време, но може да бъде променена при нужда."
          />

          <EmployeeCalendar
            employeeFieldName={nameof<IBlockedTimeWizardFormModel>(
              (x) => x.employeeId,
            )}
            dateFieldName={nameof<IBlockedTimeWizardFormModel>((x) => x.date)}
            durationFieldName={nameof<IBlockedTimeWizardFormModel>(
              (x) => x.durationInMinutes,
            )}
            employeesData={studioEmployees}
            label="Служител и дата на блокираното време"
            required
            tooltip="Изберете служителя и времето за блокираното време. Системата ще ви предупреди ако има конфликт с резервации."
            disabled={isLoading}
          />
        </>
      )}
    </>
  );
};
